// LIBRARIES //
import React from 'react';
import { Field } from 'redux-form';
import { CSSTransitionGroup } from 'react-transition-group';

import { TextField, Checkbox } from 'redux-form-material-ui';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';

// COMPONENTS //
import { RenderGhostError } from 'components/shared/RenderError';
import ReduxDropzone from 'components/shared/ReactDropzoneReduxComponent';

// HELPERS //
import { AccentColor } from 'helpers/AccentColorHelper';
import * as formatter from 'helpers/Formatter';
import { getTranslatedString } from 'helpers/i18n';
import { petPhotoAcceptedFileTypes } from 'helpers/FileHelper';

const style = {
  add_pet_button: {
    color: 'white',
  },
};

export const petsFieldArray = ({ fields, meta: { touched, error, submitFailed } }) => (
  <div className="row">
    <CSSTransitionGroup
      transitionName="add_pet"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
    >
      {fields &&
        fields.map((pet, index) => (
          <div key={index} className="row">
            <div className="cotenantHeader" style={{ padding: '0 15px', marginBottom: '-10px' }}>
              <h4 style={{ lineHeight: '26px' }}>
                {getTranslatedString('landlordPortal.petsFieldArray.petNo')}
                {index + 1}
                <IconButton
                  style={{
                    padding: 0,
                    verticalAlign: 'text-bottom',
                    width: 'none',
                    height: 'none',
                    float: 'right',
                  }}
                  onClick={() => fields.remove(index)}
                >
                  <DeleteIcon size={24} style={{ padding: 0 }} />
                </IconButton>
              </h4>
            </div>
            <div className="row" style={{ marginBottom: '10px' }}>
              <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '15px' }}>
                <Field
                  name={`${pet}.avatar`}
                  component={ReduxDropzone}
                  size={120}
                  dontShowFiles
                  circle
                  fileValidation={petPhotoAcceptedFileTypes.join(',')}
                />
              </div>
            </div>

            <div className="row" style={{ marginBottom: '10px' }}>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name={`${pet}.breed`}
                  type="text"
                  component={TextField}
                  floatingLabelText={getTranslatedString('landlordPortal.petsFieldArray.breed')}
                  style={{ marginTop: '-15px', fontSize: '14px' }}
                  errorStyle={{ fontSize: '14px' }}
                />
                <Field name={`${pet}.breed`} component={RenderGhostError} />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name={`${pet}.name`}
                  type="text"
                  component={TextField}
                  floatingLabelText={getTranslatedString('landlordPortal.petsFieldArray.name')}
                  style={{ marginTop: '-15px', fontSize: '14px' }}
                  errorStyle={{ fontSize: '14px' }}
                />
                <Field name={`${pet}.name`} component={RenderGhostError} />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name={`${pet}.weight`}
                  type="text"
                  component={TextField}
                  floatingLabelText={getTranslatedString('landlordPortal.petsFieldArray.weight')}
                  normalize={formatter.onlyNumbers}
                  style={{ marginTop: '-15px', fontSize: '14px' }}
                  errorStyle={{ fontSize: '14px' }}
                />
                <Field name={`${pet}.weight`} component={RenderGhostError} />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name={`${pet}.distinctive_markings`}
                  type="text"
                  component={TextField}
                  floatingLabelText={getTranslatedString(
                    'landlordPortal.petsFieldArray.distinctMarkings'
                  )}
                  style={{ marginTop: '-15px', fontSize: '14px' }}
                  errorStyle={{ fontSize: '14px' }}
                />
                <Field name={`${pet}.distinctive_markings`} component={RenderGhostError} />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name={`${pet}.age`}
                  type="text"
                  component={TextField}
                  floatingLabelText={getTranslatedString('landlordPortal.petsFieldArray.age')}
                  normalize={formatter.onlyNumbers}
                  style={{ marginTop: '-15px', fontSize: '14px' }}
                  errorStyle={{ fontSize: '14px' }}
                />
                <Field name={`${pet}.age`} component={RenderGhostError} />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name={`${pet}.city_license_number`}
                  type="text"
                  component={TextField}
                  floatingLabelText={getTranslatedString(
                    'landlordPortal.petsFieldArray.cityLicense'
                  )}
                  style={{ marginTop: '-15px', fontSize: '14px' }}
                />
              </div>
            </div>
            <div className="row" style={{ marginBottom: '10px' }}>
              <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '15px' }}>
                <Field
                  name={`${pet}.service_animal`}
                  component={Checkbox}
                  label={getTranslatedString('landlordPortal.petsFieldArray.serviceAnimal')}
                />
              </div>
            </div>
          </div>
        ))}
    </CSSTransitionGroup>
    <div className="row" style={{ textAlign: 'center', marginTop: '20px' }}>
      <FlatButton
        label={getTranslatedString('landlordPortal.petsFieldArray.addPet')}
        type="button"
        backgroundColor={AccentColor()}
        hoverColor="grey"
        style={style.add_pet_button}
        id="pet-button"
        onClick={() => {
          fields.push({
            avatar: 'https://s3.ca-central-1.amazonaws.com/prod-ca-central-1/public/catman.png',
            service_animal: false,
          });
        }}
      />

      {error && (
        <p
          style={{
            marginTop: '10px',
            fontSize: '11px',
            color: AccentColor(),
          }}
          id="errorMessage"
        >
          {error}
        </p>
      )}
    </div>
  </div>
);
